import type { ParsedQs } from 'qs'

import { stringParam } from './queryStringUtils'

/** True when a request originates from Google Hotel Ads. */
export function isGhaRequest(query: ParsedQs): boolean {
  return stringParam(query.utm_bp) === '3'
}
